import { render, staticRenderFns } from "./observationsPage.html?vue&type=template&id=4389c751&"
import script from "./observationsPage.vue?vue&type=script&lang=js&"
export * from "./observationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports